import {LayoutProps} from '@atsnek/jaen'

const Layout: React.FC<LayoutProps> = ({children}) => {
  return children
}

export default Layout
